<template>
    <hm-content>
        <div class="flex flex-between">
            <div>
                <el-radio-group
                        v-model="tagChange"
                        size="small"
                >
                    <el-radio-button label="list">分销商列表</el-radio-button>
                    <el-radio-button label="detail">分销商铺货明细</el-radio-button>
                </el-radio-group>
                <span style="line-height: 40px; color: #FF7F10; margin-left: 20px;">若要新增分销商请联系管理员添加</span>
            </div>
            <div v-if="tagChange == 'list'">
                <el-select v-model="searchConditionQuery.authTagId" placeholder="请选择分销商分组" size="small" class="mr10" clearable>
                    <el-option v-for="(v,i) in auth_tag_list"
                               :label="v.tagName"
                               :value="v.id"
                               :key="i"
                    ></el-option>
                </el-select>
                <el-select placeholder="请选择合作状态" size="small" class="mr10" v-model="searchConditionQuery.cooperateStatus" clearable>
                    <el-option
                            v-for="(v,i) in cooperationStatus"
                            :label="v.label"
                            :value="v.value"
                            :key="i"
                    ></el-option>
                </el-select>
                <el-input placeholder="请输入分销商名称" size="small" class="mr10" clearable v-model="searchConditionQuery.authStoreName"></el-input>
                <el-button type="primary" size="small" class="mr10" @click="queryfenXiaoShang">搜索</el-button>
            </div>
            <div v-show="tagChange == 'detail'">
                <el-select placeholder="请选择分销商" size="small" class="mr10" v-model="pitchOnDistributor" @change="conditionQuery" clearable style="width: 250px;">
                    <el-option
                        v-for="(v,i) in distributor"
                        :label="v.storeName"
                        :value="v.storeCode"
                        :key="i"
                    ></el-option>
                </el-select>
            </div>
        </div>
        <div v-show="tagChange == 'list'" style="margin-top: 20px;">
            <div style="margin-top: 10px;">
                <el-table
                        :data="destrbutorList"
                >
                    <el-table-column
                            align="cneter"
                            label="序号"
                            type="index"
                            :index="index => index + (currentPage - 1) * pageSize + 1"
                    ></el-table-column>
                    <el-table-column
                            align="center"
                            label="分销商名称"
                            prop="authStoreName"
                    ></el-table-column>
                    <el-table-column
                            align="center"
                            label="分销商分组"
                    >
                        <template slot-scope="scope">
                            <span>{{scope.row.tagName}}</span><el-button icon="el-icon-edit" @click="editTagName(scope.row)" type="text" style="color: #0081E5; font-size: 18px"></el-button>
                        </template>
                    </el-table-column>
                    <el-table-column
                            align="center"
                            label="授权产品线"
                    >
                        <template slot-scope="scope">
                            <span>{{scope.row.authGoodsLineNames}}</span><el-button type="text" @click="editShouQuanProductLine(scope.row)"  icon="el-icon-edit"  style="color: #0081E5; font-size: 18px"></el-button>
                        </template>
                    </el-table-column>
                    <el-table-column
                            align="center"
                            label="分配库存比例"
                    >
                        <template slot-scope="scope">
                            <el-input type="number" v-model="scope.row.allotStockRatio"  @blur="allotStockRatio(scope.row)" ref="allotStockRatio" size="small" align="center">
                                <template slot="append">%</template>
                            </el-input>
                        </template>
                    </el-table-column>
                    <el-table-column
                            align="center"
                            label="合作状态"
                    >
                        <template slot-scope="scope">
                            <span :style="scope.row.cooperateStatus == 'yes' ? 'color:#2FC348;' : 'color:#999999;'">{{scope.row.cooperateStatus == 'yes' ? '合作中' : '未合作'}}</span>
                        </template>
                    </el-table-column>
                </el-table>
                <el-dialog title="编辑授权产品线" :visible.sync="editShouQuanProductLineWindow" @open="searchSelectiList" width="30%">
                    <div class="flex flex-column">
                        <span>产品线：{{tableRow.authGoodsLineNames}}</span>
                        <div style="margin: 10px 0;">
                            <span>请选择授权产品线：</span>
                            <el-select v-model="ShouQuanProductLine" @change="sqp" placeholder="请选择授权产品线" size="small" class="mr10" multiple style="width: 300px">
                                <el-option v-for="(v,i) in selectionList"
                                           :label="v.name"
                                           :value="{value:v.id,label:v.name}"
                                           :key="i"
                                ></el-option>
                            </el-select>
                        </div>
                    </div>
                    <div class="flex flex-center">
                        <el-button type="primary" @click="ShouQuanProductLineSave">保存</el-button>
                    </div>
                </el-dialog>
                <div class="hm-pagination">
                    <el-pagination
                            background
                            :total="total"
                            @current-change="paging"
                            @size-change="handleSizeChange"
                            layout="total, sizes, prev, pager, next, jumper"
                            :current-page="currentPage"
                    ></el-pagination>
                </div>
            </div>
        </div>
        <div v-if="tagChange == 'detail'" style="margin-top: 20px;">
            <el-table
                    :data="ShopGoodsList"
            >
                <el-table-column
                        align="cneter"
                        label="序号"
                        type="index"
                        :index="index => index + (currentPage - 1) * pageSize + 1"
                ></el-table-column>
                <el-table-column
                        align="center"
                        label="商品名称"
                        prop="spuName"
                        width="300"
                ></el-table-column>
                <el-table-column
                        align="center"
                        label="商品货号"
                        prop="goodsSn"
                ></el-table-column>
                <el-table-column
                        align="center"
                        label="分销商品名称"
                        prop="spuName"
                        width="300"
                ></el-table-column>
                <el-table-column
                        align="center"
                        label="建议零售价"
                >
                    <template slot-scope="scope">
                        <span>￥{{scope.row.showRecommendedRetailPrice}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                        align="center"
                        label="采购价"
                >
                    <template slot-scope="scope">
                        <span>￥{{scope.row.showPurchasePrice}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                        align="center"
                        label="商城售价"
                >
                    <template slot-scope="scope">
                        <span>￥{{scope.row.showWxshopPrice}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                        align="center"
                        label="上架状态"
                        prop="onState"
                >
                    <template slot-scope="scope">
                        <span :style="scope.row.onState == '上架'? 'color:green' : 'color:red'">{{scope.row.onState}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                        align="center"
                        label="分销商名称"
                        prop="shareStoreName"
                        width="300"
                ></el-table-column>
            </el-table>
            <div class="hm-pagination">
                <el-pagination
                        background
                        :total="totals"
                        @current-change="pagings"
                        @size-change="handleSizeChanges"
                        layout="total, sizes, prev, pager, next, jumper"
                        :current-page="currentPages"
                ></el-pagination>
            </div>
        </div>
        <el-dialog title="编辑分销商分组" :visible.sync="editTagNameWindon" width="30%">
            <div class="flex flex-column">
                <span>分销商：{{tableRow.authStoreName}}</span>
                <div style="margin: 10px 0;">
                    <span>请选择分销商分组：</span>
                    <el-select v-model="authStoreGroup" placeholder="请选择分销商分组" size="small" class="mr10">
                        <el-option v-for="(v,i) in auth_tag_list"
                            :label="v.tagName"
                            :value="v.id"
                            :key="i"
                        ></el-option>
                    </el-select>
                    <el-button type="text" @click="addTagNameWindon=true" class="mr10" >新增分销商分组</el-button>
                    <el-dialog title="新增分销商分组" :visible.sync="addTagNameWindon" width="20%" append-to-body>
                        <div class="flex flex-start">
                            <span class="mr10" style="line-height: 30px">请输入分组名称：</span><el-input placeholder="请输入分组名称" size="small" v-model="addTagName" style="width: 200px"></el-input>
                        </div>
                        <div class="flex flex-center">
                            <el-button type="primary" size="small" @click="addAuthStore" style="margin-top: 15px;">确认添加</el-button>
                        </div>
                    </el-dialog>
                </div>
            </div>
            <div class="flex flex-center">
                <el-button type="primary" @click="editTagNameSave">保存</el-button>
            </div>
        </el-dialog>

    </hm-content>
</template>
<script>
    export default {
        data(){
            return{
                cooperateStatus:'',   //合作状态
                cooperationStatus:[
                    {
                    label: '合作中',
                    value:'yes'
                    },
                    {
                        label: '未合作',
                        value:'no'
                    }],
                ShouQuanProductLine:[],
                editShouQuanProductLineWindow:false,
                addTagName:'',
                addTagNameWindon:false,
                authStoreGroup:'',
                authStoreGroupId:'',
                editTagNameWindon:false,
                ShopGoodsList:[],    //分销铺货明细查询
                destrbutorList:[],   //分销商列表
                tagChange:"list",
                pitchOnDistributor:'',
                distributor:[],
                total:0,
                currentPage:1,
                pageSize:10,
                totals:0,
                currentPages:1,
                pageSizes:10,
                tableRow:[],
                auth_tag_list:[],
                selectionList:[],
                searchConditionQuery:{
                    authStoreName:'',
                    cooperateStatus:'',
                    authTagId:''
                }
            }
        },
        mounted() {
            this.queryTagList();
            this.queryfenXiaoShang();
            this.query_distribution_list();
            this.query_share_store_list();
        },
        methods:{
            async allotStockRatio(val){   //分配库存比例
                if(val.allotStockRatio < 0 || val.allotStockRatio > 100 ){
                    this.$message({
                        title: '警告',
                        message: '输入数字不能小于0%或大于100%！请重新输入',
                        type: 'warning'
                    });
                    this.$refs.allotStockRatio.focus();
                    return false;
                };
                let params = {
                    id:val.id,
                    allotStockRatio:val.allotStockRatio
                };
                await this.$store.dispatch("auth_store_edit",params);
                this.$message({
                    message: '恭喜你，调整成功',
                    type: 'success'
                });
            },
            sqp(data){
                console.log(data)
            },
            async ShouQuanProductLineSave(){  //授权产品线保存
                if(this.ShouQuanProductLine.length == 0){
                    this.$notify({
                        title: '警告',
                        message: '请选择至少一个产品线',
                        type: 'warning'
                    });
                    return false;
                }
                let params = {
                    id:this.tableRow.id,
                    goodsLineIdList:[]
                };
                this.ShouQuanProductLine.forEach(v => {
                    params.goodsLineIdList.push(v.value);
                });
                console.log("par:",params)
                await this.$store.dispatch("auth_store_edit",params)
                this.$message({
                    message: '恭喜你，编辑成功',
                    type: 'success'
                });
                this.editShouQuanProductLineWindow = false;
                this.queryfenXiaoShang();
            },
            //查询产品线列表
            async searchSelectiList(){
                this.ShouQuanProductLine = [];
                const { result } = await this.$store.dispatch("ProductLineList");
                console.log(result);
                this.selectionList = result;
            },
            //编辑授权产品线
            editShouQuanProductLine(val){
                this.editShouQuanProductLineWindow = true;
                this.tableRow = val;
            },
            //新增分销商分组
            async addAuthStore(){
                let params = {
                    tagName:this.addTagName
                }
                await this.$store.dispatch("auth_tag_add",params);
                this.$message({
                    message: '新增成功辣！',
                    type: 'success'
                });
                this.addTagNameWindon = false;
                this.queryTagList();
            },
            //查询分销商分组
            async queryTagList(){
                const { result } = await this.$store.dispatch("auth_tag_list");
                this.auth_tag_list = result;
            },
            //编辑分销商分组
            editTagName(val){
                this.tableRow = val;
                this.editTagNameWindon = true;
            },
            async editTagNameSave(){
                let params = {
                    id:this.tableRow.id,
                    authTagId:this.authStoreGroup
                };
                console.log("par:",params)
                await this.$store.dispatch("auth_store_edit",params)
                this.$message({
                    message: '恭喜你，编辑成功',
                    type: 'success'
                });
                this.editTagNameWindon = false;
                this.queryfenXiaoShang();
            },
            //查询分销商列表
            async queryfenXiaoShang(){
                let params = {
                    pageSize:this.pageSize,
                    pageNo: this.currentPage
                }
                const searchCondition = JSON.parse(JSON.stringify(this.searchConditionQuery))
                Object.assign(params,searchCondition);
                const { result } = await this.$store.dispatch("auth_share_store_list",params);
                this.destrbutorList = result.records;
                this.total = result.total;
            },
            conditionQuery(){
                this.currentPages = 1;
                this.query_distribution_list()
            },
            //分销商查询
            async query_share_store_list(){
                const { result } = await this.$store.dispatch("share_store_list");
                console.log(result);
                this.distributor = result;

            },
            //分销铺货明细查询
            async query_distribution_list(){
                let params = {
                  pageSize:this.pageSizes,
                  pageNo:this.currentPages,
                  storeCode:this.pitchOnDistributor
                };
                const { result } = await this.$store.dispatch("distribution_list",params);
                this.ShopGoodsList = result.records;
                this.totals = result.total;
            },
            paging(page) {
                this.currentPage = page;
                //       this.queryList();
            },
            handleSizeChange(size) {
                this.currentPage = 1;
                this.pageSize = size;
                //       this.queryList();
            },
            pagings(page) {
                this.currentPages = page;
                this.query_distribution_list();
            },
            handleSizeChanges(size) {
                this.currentPages = 1;
                this.pageSizes = size;
                this.query_distribution_list();
            },

        }
    }

</script>
<style></style>